import Index from './index'
import Listar from './Listar'
import Detalhes from './Detalhes'
import Editar from './Editar'

const route = {
  path: '/agendamentos',
  name: 'agendamentos',
  component: Index,
  children: [
    { path: 'listar', name: 'agendamentos-listar', component: Listar, props: { titulo: 'Listar', status: null } },
    { path: 'listar-aguardando-agendamento', name: 'agendamentos-listar-guardando-agendamento', component: Listar, props: { titulo: 'Listar Aguardando Agendamento', status: 1 } },
    { path: 'listar-agendados', name: 'agendamentos-listar Agendados', component: Listar, props: { titulo: 'Listar Agendados', status: 2 } },
    { path: 'listar-em-andamento', name: 'agendamentos-listar-em-andamento', component: Listar, props: { titulo: 'Listar Em Andamento', status: 3 } },
    { path: 'listar-finalizados', name: 'agendamentos-listar-finalizados', component: Listar, props: { titulo: 'Listar Finalizados', status: 4 } },
    { path: 'listar-nao-executados', name: 'agendamentos-listar-nao-executados', component: Listar, props: { titulo: 'Listar Não Executados', status: 5 } },
    { path: 'listar-cancelados', name: 'agendamentos-listar-cancelados', component: Listar, props: { titulo: 'Listar Cancelados', status: 9 } },
    { path: ':id', name: 'agendamentos-detalhes', component: Detalhes, props: true },
    { path: ':id/e', name: 'agendamentos-editar', component: Editar, props: true }
  ],
  meta: { requiresAuth: true }
}

export default route



// WEBPACK FOOTER //
// ./src/pages/agendamentos/routes.js